/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Col, Form, Input, Row, Spin, Switch } from 'antd';
import React, { useState, useContext } from 'react';
import styles from './styles.module.scss';
import {
  IsAdminContext,
  NumberOfEducationContext,
  UserEducationDataContext,
} from '../../../../../../../context';
import axiosInstance from '../../../../../../../axios_instance';
import { useParams } from 'react-router-dom';
import { errorHandling } from '../../../../../../../utils/helper';
import errorColumnMap from '../../../../../../../utils/error-message-mapping';
import { TextLengthValidator } from '../../../../../../../utils/validators';

interface EditEducationProps {
  education_id: number;
  school_name: string;
  degree_name: string;
  passing_year: number;
  grade: number;
  setIsEditable: any;
  show_in_resume: boolean;
}

const EditEducation: React.FC<EditEducationProps> = ({
  education_id,
  school_name,
  degree_name,
  passing_year,
  grade,
  setIsEditable,
  show_in_resume
}) => {
  const [formData, setFormData] = useState<{ [key: string]: number | string }>({
    education_id,
    school_name,
    degree_name,
    passing_year,
    grade,
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { userEducationData, setUserEducationData } = useContext(
    UserEducationDataContext
  );
  const [errorMessage, setErrorMessage] = useState<any>({});
  const { numberOfEducation, setNumberOfEducation } = useContext(NumberOfEducationContext)

  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  const handleChangeResume = (value: any) => {
    setFormData({
      ...formData,
      ["show_in_resume"]: value,
    });
  };

  const handleSave = () => {
    const requestBody: { [key: string]: any } = {};
    requestBody['education_id'] = formData['education_id'];
    requestBody['degree_name'] = formData['degree_name'];
    requestBody['school_name'] = formData['school_name'];
    requestBody['passing_year'] = formData['passing_year'];
    requestBody['show_in_resume'] = 'show_in_resume' in formData ? formData['show_in_resume'] : show_in_resume;
    requestBody['grade'] = formData['grade'];
    requestBody['status'] = 1;
    if (
      requestBody['degree_name'] !== degree_name ||
      requestBody['school_name'] !== school_name ||
      requestBody['passing_year'] !== passing_year ||
      requestBody['grade'] !== grade ||
      requestBody['show_in_resume'] !== show_in_resume
    ) {
      let url = '';
      if (isAdmin === '1') {
        url = '/api/v1/admin/profile/educations';
        requestBody['profile_id'] = employeeId;
      } else {
        url = '/api/v1/profile/educations';
      }
      axiosInstance
        .post(url, requestBody)
        .then((response) => {
          const orderedEducations = response.data.order.map((educationId: number) =>
            response.data.educations.find((education: any) => education.education_id === educationId)
          ).filter((item: any) => item !== undefined);
          setUserEducationData(orderedEducations);
          setNumberOfEducation(orderedEducations.length);
          setIsEditable(false);
        })
        .catch((error) => {
          errorHandling(error, setErrorMessage);
        })
        .finally(() => {

          setIsSubmitted(false)
        });
    } else {
      setIsEditable(false);
    }
  };

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row className={styles.row}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", position: "absolute", bottom: "8px", right: "8px" }}><Switch defaultChecked={show_in_resume} onChange={handleChangeResume} /><span>Show in resume</span></div>
          <Col span={12}>
            <Row>
              <Form.Item
                name="degree_name"
                label=""
                initialValue={degree_name}
                rules={[TextLengthValidator]}
              >
                <p>
                  <span className={styles.title}>Degree Name : </span>
                  <Input
                    type="text"
                    className={styles.input}
                    name="degree_name"
                    onChange={handleChange}
                    defaultValue={degree_name}
                    style={{
                      borderBottom:
                        'degree_name' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'degree_name' in errorMessage
                  ? errorMessage['degree_name']
                  : ''}
              </p>
            </Row>
            <Row>
              <Form.Item
                name="school_name"
                label=""
                initialValue={school_name}
                rules={[TextLengthValidator]}
              >
                <p>
                  <span className={styles.title}>Institute Name : </span>
                  <Input
                    type="text"
                    className={styles.input}
                    name="school_name"
                    onChange={handleChange}
                    defaultValue={school_name}
                    style={{
                      borderBottom:
                        'school_name' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'school_name' in errorMessage
                  ? errorMessage['school_name']
                  : ''}
              </p>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Form.Item
                name="passing_year"
                initialValue={passing_year}
                label=""
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        (value > 1970 &&
                          value <= Number(new Date().getFullYear()))
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          'Input a valid year between 1970 and current year!'
                        )
                      );
                    },
                  }),
                ]}
              >
                <p>
                  <span className={styles.title}>Passing Year : </span>
                  <Input
                    className={styles['input-small']}
                    onChange={handleChange}
                    name="passing_year"
                    defaultValue={passing_year}
                    style={{
                      borderBottom:
                        'passing_year' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'passing_year' in errorMessage
                  ? errorMessage['passing_year']
                  : ''}
              </p>
            </Row>
            <Row>
              <Form.Item
                name="grade"
                initialValue={grade}
                label=""
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_: any, value: any) {
                      if (!value || value.length <= 30) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error('Ensure the value has at most 30 characters.')
                      );
                    },
                  }),
                ]}
              >
                <p>
                  <span className={styles.title}>Cgpa : </span>
                  <Input
                    className={styles['input-small']}
                    onChange={handleChange}
                    name="grade"
                    defaultValue={grade}
                    style={{
                      borderBottom:
                        'grade' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'grade' in errorMessage ? errorMessage['grade'] : ''}
              </p>
            </Row>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
              type="primary"
              htmlType="submit"
            >
              Save
            </Button>
          </Form.Item>
          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onClick={(e) => {
              setIsEditable(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default EditEducation;
